import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Home, PieChart, ArrowRightLeft, User, Shield, LogOut } from 'lucide-react';
import AccountSidebar from './AccountSidebar';
import AccountNavbar from './AccountNavbar';

const AccountLayout = ({ children }: { children: React.ReactElement }) => {
  const [userData, setUserData] = useState<any>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // Nav Items Mobile Menu Ke Liye
  const navItems = [
    { name: 'Home', icon: Home, path: '/account/dashboard' },
    { name: 'Portfolio', icon: PieChart, path: '/account/portfolio' },
    { name: 'Transactions', icon: ArrowRightLeft, path: '/account/transactions' },
    { name: 'Profile', icon: User, path: '/account/profile' },
    { name: 'Security', icon: Shield, path: '/account/security' },
  ];

  useEffect(() => {
    const storedUser = localStorage.getItem('tradingUser');
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    } else {
      navigate('/demat/register');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('tradingUser');
    navigate('/demat/register');
  };

  if (!userData) {
    return <div className="h-screen bg-[#0b1221] flex items-center justify-center text-blue-500 font-bold">Securely Loading...</div>;
  }

  return (
    <div className="flex h-screen bg-[#050b14] text-white font-sans overflow-hidden">
      {/* Desktop Sidebar */}
      <AccountSidebar onLogout={handleLogout} />
      
      <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        <AccountNavbar userData={userData} onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
        
        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className="absolute top-20 left-0 w-full bg-[#131b2c] border-b border-gray-800 z-50 p-4 md:hidden shadow-2xl flex flex-col gap-2">
            
            {/* Saare Navigation Links */}
            {navItems.map((item) => {
              const isActive = currentPath === item.path;
              return (
                <Link 
                  key={item.name} 
                  to={item.path} 
                  onClick={() => setIsMobileMenuOpen(false)} // Link pe click hote hi menu band
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-all ${isActive ? 'bg-blue-600/10 text-blue-500' : 'text-gray-400 hover:bg-[#1e222d] hover:text-gray-200'}`}
                >
                  <item.icon size={20} /> {item.name}
                </Link>
              );
            })}

            <div className="h-px bg-gray-800 my-2"></div> {/* Divider */}

            {/* Logout Button */}
            <button onClick={handleLogout} className="flex items-center justify-center gap-2 w-full py-3 text-center text-red-400 font-bold bg-red-500/10 hover:bg-red-500/20 transition-colors rounded-xl">
              <LogOut size={20} /> Logout
            </button>
          </div>
        )}

        {/* Main Content Render */}
        <main className="flex-1 overflow-y-auto custom-scrollbar p-4 md:p-8">
          {React.cloneElement(children as React.ReactElement<any>, { userData })}
        </main>
      </div>
    </div>
  );
};

export default AccountLayout;